import { FC } from 'react';
import { BellMinus, BellOff, BellPlus, BellRing, LucideProps } from 'lucide-react';

const alertIconProps = {
    'aria-hidden': true,
    focusable: false,
    size: '1rem',
    strokeWidth: 1.75,
} as const;

export const AlertIcon: FC<LucideProps> = (props) => <BellRing {...alertIconProps} {...props} />;
export const CreateAlertIcon: FC<LucideProps> = (props) => <BellPlus {...alertIconProps} {...props} />;
export const RemoveAlertIcon: FC<LucideProps> = (props) => <BellMinus {...alertIconProps} {...props} />;
export const PausedAlertIcon: FC<LucideProps> = (props) => <BellOff {...alertIconProps} {...props} />;
